// @flow

const delay = (time: number = 0) => {
  return (new Promise(resolve => {
    setTimeout(resolve, time);
  }): Promise<void>);
};

export default delay;
